import type { FaireProductEntity } from "../../entity_types/product";

export const p_a3uybcqwd5: FaireProductEntity = {
  token: "p_a3uybcqwd5",
  type: "product",
  name: "Confetti Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/03afd525e0419a93ce6ca97312f13d20667923c09066b4cc56b9839ee50d5ec0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c1e3f683ac93ae9e4e2cd38f85bc1d3f4f741695feeb2b9bc4acf930f71c72e6.png",
    "https://cdn.faire.com/fastly/234774bb49bb653e702b32fe61ea7950dc73b97eb95305a5d87d8529b2f68002.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:01.211Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
